const REGISTER = {
  GET_ACCOUNT_STATUS: 'GET_ACCOUNT_STATUS',
  GET_ACCOUNT_STATUS_SUCCESS: 'GET_ACCOUNT_STATUS_SUCCESS',
  GET_ACCOUNT_STATUS_FAILURE: 'GET_ACCOUNT_STATUS_FAILURE',
  UPDATE_ERROR: 'UPDATE_ERROR',
  UPDATE_FIELD_VALUE: 'UPDATE_FIELD_VALUE',
  UPDATE_ACCOUNT_STATUS: 'UPDATE_ACCOUNT_STATUS',
  GET_FACILITIES: 'GET_FACILITIES',
  GET_FACILITIES_SUCCESS: 'GET_FACILITIES_SUCCESS',
  GET_FACILITIES_FAILURE: 'GET_FACILITIES_FAILURE',
  DISPLAY_TOAST: 'DISPLAY_TOAST',
  UPDATE_ADMIN_TERMS: 'UPDATE_ADMIN_TERMS',
  UPDATE_ADMIN_TERMS_SUCCESS: 'UPDATE_ADMIN_TERMS_SUCCESS',
  UPDATE_ADMIN_TERMS_FAILURE: 'UPDATE_ADMIN_TERMS_FAILURE',
};

export { REGISTER };
